import { Redirect } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { FORM_VALIDATION_RULES } from '../../constants/validations/validations';
import { ButtonWrapper, Layout } from './login.styles';
import GoogleIcon from '../../components/icons/google';

import { useLoginData } from './login.hooks';
import { baseURL } from '../../constants/url';
import React from 'react';
import { LoginPageProps, LoginValues } from '../../interfaces/login';
import Quote from '../../components/quote/quote.component';

const { requiredUsername, requiredPassword } = FORM_VALIDATION_RULES;

const formLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const LoginPage: React.FC<LoginPageProps> = ({ isAuthChecking, login }) => {
  const { user } = useLoginData();
  const onFinish = (values: LoginValues) => {
    login(values);
  };

  return user && user.isAuthenticated === false ? (
    <Layout>
      <Quote />
      <Form {...formLayout} name="basic" initialValues={{ remember: true }} onFinish={onFinish}>
        <Form.Item label="Username" name="username" rules={[requiredUsername]}>
          <Input data-test-id="username" disabled={isAuthChecking} />
        </Form.Item>

        <Form.Item label="Password" name="password" rules={[requiredPassword]}>
          <Input.Password data-test-id="password" disabled={isAuthChecking} />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button
            data-test-id="submit"
            type="primary"
            htmlType="submit"
            disabled={isAuthChecking}
            formNoValidate={true}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
      <ButtonWrapper>
        <Button className="gsi-material-button" href={`${baseURL}/api/auth/google`}>
          <div className="gsi-material-button-state" />
          <div className="gsi-material-button-content-wrapper">
            <div className="gsi-material-button-icon">
              <GoogleIcon />
            </div>
            <span className="gsi-material-button-contents">Sign in with Google</span>
            <span style={{ display: 'none' }}>Sign in with Google</span>
          </div>
        </Button>
      </ButtonWrapper>
    </Layout>
  ) : (
    user && <Redirect to="/" />
  );
};

export default LoginPage;
